import { BaseDTO } from '../basedto';
import { PartInfo } from '../partinfo';
import { Constants } from 'src/app/core/constants';
import { DueDateExtensionHistoryDTO } from 'src/app/models/duedateextensionhistory-dto';

export class PendingProposalPartInfo extends PartInfo {
    ProposalId: number;
    Note: string;
    CreatedOn: Date;
    DemandDate: Date;
    DueDate: Date;
    TransportModeId: number;
    PackageTypeId: number;
    DueDateExtensionHistory: DueDateExtensionHistoryDTO[];
    ShipDate: Date;

    constructor() {
        super();
        this.Material = Constants.DEFAULT_PART_MATERIAL;
        this.DueDateExtensionHistory = [];
    }
}
